import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  StyledPF,
  StyledMixedJourney,
  StyledMixedJourneyContainer,
  StyledWarningCtaMultiplePFSpan,
  StyledContainerOverflow
} from './WarningCta.styles';

const WarningCtaMixedJourney = ({ faresForPassengersInMixedJourney = {} }) => (
  <StyledContainerOverflow>
    {faresForPassengersInMixedJourney?.singleFares?.length > 0 && (
      <StyledMixedJourneyContainer>
        <StyledMixedJourney>
          {' '}
          <FormattedMessage id="warningMixedJourney.singleFares" />:{' '}
        </StyledMixedJourney>
        <div>
          {faresForPassengersInMixedJourney.singleFares.map((s, index) => (
            <StyledWarningCtaMultiplePFSpan key={`${s.ticketNumber}--${index}`}>
              <StyledPF>
                <FormattedMessage id="clubEurostar.ticketNumber" />:
              </StyledPF>{' '}
              {s.ticketNumber} -{' '}
              <StyledPF>
                <FormattedMessage id="reviewScreen.passenger" />:
              </StyledPF>{' '}
              {s.passengerId} ({s.passenger?.firstName} {s.passenger?.lastName})
            </StyledWarningCtaMultiplePFSpan>
          ))}
        </div>
      </StyledMixedJourneyContainer>
    )}

    {faresForPassengersInMixedJourney?.returnFares?.length > 0 && (
      <StyledMixedJourneyContainer>
        <StyledMixedJourney>
          {' '}
          <FormattedMessage id="warningMixedJourney.returnFares" />:{' '}
        </StyledMixedJourney>
        <div>
          {faresForPassengersInMixedJourney.returnFares.map((s, index) => (
            <StyledWarningCtaMultiplePFSpan key={`${s.ticketNumber}--${index}`}>
              <StyledPF>
                <FormattedMessage id="clubEurostar.ticketNumber" />:
              </StyledPF>{' '}
              {s.ticketNumber} -{' '}
              <StyledPF>
                <FormattedMessage id="reviewScreen.passenger" />:
              </StyledPF>{' '}
              {s.passengerId} ({s.passenger?.firstName} {s.passenger?.lastName})
            </StyledWarningCtaMultiplePFSpan>
          ))}
        </div>
      </StyledMixedJourneyContainer>
    )}
  </StyledContainerOverflow>
);

WarningCtaMixedJourney.propTypes = {
  faresForPassengersInMixedJourney: PropTypes.shape({
    singleFares: PropTypes.arrayOf(
      PropTypes.shape({
        passengerId: PropTypes.string,
        ticketNumber: PropTypes.string
      })
    ),
    returnFares: PropTypes.arrayOf(
      PropTypes.shape({
        passengerId: PropTypes.string,
        ticketNumber: PropTypes.string
      })
    )
  })
};

export default WarningCtaMixedJourney;
